export const calculateSumTaxes = (oldTaxes, newTaxes) => {
    let sumTaxes = [];
    newTaxes.map((tax) => {
        let oldIndex = oldTaxes.findIndex((x) => x.TTax === tax.TTax);
        if (oldIndex !== -1) {
            oldTaxes[oldIndex].value = oldTaxes[oldIndex].value + tax.value;
            sumTaxes.push(oldTaxes[oldIndex]);
        } else {
            sumTaxes.push(tax);
        }
        return null;
    });

    return sumTaxes;
}

export const calculateSumDiscound = (oldDiscount, newDiscount) => {
    let sumDiscount = [];
    newDiscount.forEach((disc) => {
        let oldIndex = oldDiscount.findIndex((x) => x.discount_name === disc.discount_name);
        if (oldIndex !== -1) {
            // Combine the amounts for the same discount_name
            const combinedDiscount = {
                ...oldDiscount[oldIndex],
                amount: (Number(oldDiscount[oldIndex].amount) || 0) + (Number(disc.amount) || 0),
            };
            sumDiscount.push(combinedDiscount);
        } else {
            sumDiscount.push({...disc});
        }
    });

    return sumDiscount;
}